import { defineMessages } from 'react-intl';
import * as Actions from '../../../../store/csw/csw.actions';
import * as InventoryActions from '../../../../store/inventory/inventory.actions';

const messages = defineMessages({
  createAndPrintLabel: {
    description: 'cswPrimaryActions.createAndPrintLabel',
    defaultMessage: 'Create + Print Label',
    id: 'HWc2K7',
  },
});

export const createAndPrintLabel = {
  id: 'createAndPrintLabel',
  translation: messages.createAndPrintLabel,

  getActionFromFulfillmentPlanId: (fulfillmentPlanId) => {
    window.labelPrintStart = window.performance.now();
    return InventoryActions.allocateFulfillmentPlanFromOrderDetailsCsw(
      fulfillmentPlanId,
      Actions.createLabel(fulfillmentPlanId, true, false),
    );
  },
};
